module.exports = __webpack_public_path__ + "img/lhc.98bc0532.jpg";